import type { OwaHeaderButtonControl } from "owa-header-types";

export type ResolveHeaderButtonWidth = (button: OwaHeaderButtonControl) => number | undefined;

export interface HeaderButtonSizingStore {
    getSnapshot: () => ResolveHeaderButtonWidth | undefined;
    subscribe: (onChange: () => void) => () => void;
    update: (resolveWidth: ResolveHeaderButtonWidth) => void;
}

export function createHeaderButtonSizingStore(): HeaderButtonSizingStore {
    let snapshot: ResolveHeaderButtonWidth | undefined;
    const listeners = new Set<() => void>();
    return {
        getSnapshot: () => snapshot,
        subscribe: onChange => {
            listeners.add(onChange);
            return () => {
                listeners.delete(onChange);
            };
        },
        update: resolveWidth => {
            if (snapshot !== resolveWidth) {
                snapshot = resolveWidth;
                listeners.forEach(onChange => onChange());
            }
        },
    };
}
